import endPoints from '../../config/endPoints';

const SOCIAL_DATA = [
  {
    name: `<img src='${endPoints.TWITTER_ICON.URL}' alt="twitter" />`,
    link: 'https://twitter.com/zaggleapp',
  },
  {
    name: `<img src='${endPoints.WHATSAPP_ICON.URL}' alt="whatsapp" />`,
    link: 'https://api.whatsapp.com/send/?phone=918367723456&text&app_absent=0',
  },
  {
    name: `<img src='${endPoints.YOUTUBE_ICON.URL}' alt="youtube" />`,
    link: 'https://www.youtube.com/channel/UCF44bUtUAgnMNOTzyvXvkgQ?view_as=subscriber',
  },
  {
    name: `<img src='${endPoints.INSTAGRAM_ICON.URL}' alt="instagram" />`,
    link: 'https://www.instagram.com/zaggleapp/',
  },
  {
    name: `<img src='${endPoints.FACEBOOK_ICON.URL}' alt="facebook" />`,
    link: 'https://www.facebook.com/zaggleapp/',
  },
  {
    name: `<img src='${endPoints.LINKEDIN_ICON.URL}' alt="linkedin" />`,
    link: 'https://www.linkedin.com/company/zaggleapp/',
  },
];

export default SOCIAL_DATA;



// WEBPACK FOOTER //
// client/components/FooterNew/SocialData.js